var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdpApplication = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 97 114"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.258 26.532v85.305h63.395V46.262l-17.508-19.73z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BBBCBC",
  d: "M69.939 35.706 56.383 22.15H0V114h74.613v-73.62zm-2.396 71.224H7.07V29.22h39.264v21.21h21.21z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28.855 50.421h45.759v63.538H28.855z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF832B",
  d: "M67.654 57.417v24.737H92.39V57.418zm17.67 17.67H74.721V64.485h10.601z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF832B",
  d: "M60.586 71.553H35.849v42.407h42.407V89.222h-17.67zm-7.068 35.339H42.916V96.29h10.602zm17.67-10.602v10.602H60.586V96.29zm-28.272-7.068V78.621h10.602v10.601z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BBBCBC",
  strokeLinecap: "round",
  strokeWidth: 2.908,
  d: "m75.668 21.18 8.962-8.86"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BBBCBC",
  strokeLinecap: "round",
  strokeWidth: 2.908,
  d: "M1.454-1.454h7.755",
  transform: "matrix(.00578 -.99998 -.99998 -.00578 65.05 19.939)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BBBCBC",
  strokeLinecap: "round",
  strokeWidth: 2.908,
  d: "m78.324 30.442 7.755.045"
})));
export default SvgIdpApplication;